<template>
  <div class="orderGoods">
    <div class="total">{{ cartInfo.length }} Item</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
      >
        <div class="pictrue">
          <img v-if="gameState==2" :src="cart.productInfo.up_image" class="image" />
          <img v-else :src="cart.productInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1" v-if="gameState==2">{{ cart.productInfo.up_store_name }}</div>
            <div class="name line1" v-else>{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>

          <div class="money font-color-red"  v-if="gameState==2">₱{{ cart.upTruePrice }}</div>
          <div class="money font-color-red" v-else>₱{{ cart.truePrice }}</div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    gameState:{
      type: String,
      default:0,
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
